import './lib/sentry'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { SentryErrorBoundary } from './components/SentryErrorBoundary'
import { ToastProvider } from './contexts/ToastContext'
import { PostHogProvider } from './providers/PostHogProvider'
import App from './App'
import './index.css'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <PostHogProvider>
          <SentryErrorBoundary>
            <ToastProvider>
              <App />
            </ToastProvider>
          </SentryErrorBoundary>
        </PostHogProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
)

